import { useFormikContext } from "formik";
import draftToHtml from "draftjs-to-html";
import htmlToDraft from "html-to-draftjs";
import { Editor } from "react-draft-wysiwyg";
import React, { useEffect, useState } from "react";
import { EditorState, convertToRaw, ContentState } from "draft-js";
// component
import { LabelField } from "components/LabelField";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
// direct import
import "./style.scss";
import { fontConfig } from "theme/fontConfig";

const TextEditor = ({
  name = "description",
  title = "",
  titleStyle = {
    fontFamily: fontConfig.FormManageTextEditorTitleStyleFont.family,
    fontWeight: "400",
    fontSize: "12px",
    lineHeight: "18px",
    color: "#4F4F4F",
  },
}) => {
  const formik = useFormikContext();

  const initialContentBlock =
    typeof window !== "undefined"
      ? htmlToDraft(formik.values?.[name] || "")
      : null;

  const initialEditorState = initialContentBlock
    ? EditorState.createWithContent(
        ContentState.createFromBlockArray(initialContentBlock.contentBlocks)
      )
    : EditorState.createEmpty();

  const [editorState, setEditorState] = useState(initialEditorState);

  const onEditorStateChange = (newState) => {
    setEditorState(newState);
  };

  useEffect(() => {
    const html = draftToHtml(convertToRaw(editorState.getCurrentContent()));
    formik.setFieldValue(name, html);
  }, [editorState]);

  const toolbarOptions = {
    options: [
      "inline",
      "blockType",
      "fontSize",
      "fontFamily",
      "list",
      "textAlign",
      "colorPicker",
      "link",
      "remove",
    ],
    inline: {
      options: ["bold", "italic", "underline", "strikethrough"],
    },
    blockType: {
      options: ["Normal", "H1", "H2", "H3", "H4", "H5", "H6", "Blockquote"],
    },
    fontSize: {
      options: [12, 14, 16, 18, 24, 30, 36, 48],
    },
    fontFamily: {
      options: [
        "Roboto",
        "Poppins",
        "Courier",
        "Courier-Bold",
        "Courier-Oblique",
        "Courier-BoldOblique",
        "Helvetica",
        "Helvetica-Bold",
        "Helvetica-Oblique",
        "Helvetica-BoldOblique",
        "Times-Roman",
        "Times-Italic",
      ],
    },
    list: {
      options: ["unordered", "ordered"],
    },
    textAlign: {
      options: ["left", "center", "right"],
    },
    colorPicker: {
      colors: [
        "rgb(0,0,0)",
        "rgb(255,255,255)",
        "rgb(255,0,0)",
        "rgb(255,153,0)",
        "rgb(255,255,0)",
        "rgb(0,255,0)",
        "rgb(0,255,255)",
        "rgb(0,0,255)",
        "rgb(153,0,255)",
        "rgb(255,0,255)",
      ],
    },
    link: {
      options: ["link", "unlink"],
    },
  };

  return (
    <>
      {title && <LabelField title={title} style={titleStyle} />}
      <div className="wysiwyg_container">
        <div className="col-md-12 editor h-100">
          <Editor
            editorState={editorState}
            onEditorStateChange={onEditorStateChange}
            toolbar={toolbarOptions}
            toolbarClassName="toolbarClassName"
            wrapperClassName="wrapperClassName"
            editorClassName="editorClassName"
          />
        </div>
      </div>
    </>
  );
};

export default TextEditor;
